<template>
    <v-container flex grid-list-lg>
    <template v-if="!smartLock">
      <smart-lock-message></smart-lock-message>
    </template>
    <v-layout
      column
      wrap
      v-else
    >
      <v-toolbar
        color="#eee"
        class="
          elevation-0
          secondary--text
          mb-4
        "
        style="background: transparent"
      >
        <v-toolbar-title>
          Meios de Recebimento {{ empresas ? 'Dos Postos' : 'Da Apetrus' }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              round
              color="primary"
              @click="empresas = !empresas"
              v-on="on"
              icon
            >
              <v-icon>{{
                empresas ? 'paid' :
                            'domain'
                }}
              </v-icon>
            </v-btn>
          </template>
              {{
                empresas ? 'Visualizar meios de recebimentos da Apetrus' :
                           'Visualizar meios de recebimentos do Posto'
              }}
        </v-tooltip>
        <v-tooltip
          bottom
        >
          <template v-slot:activator="{ on }">
            <v-btn icon color="primary"
              v-on="on"
              @click="cadRecegbimento = true"
            >
              <v-icon>add</v-icon>
            </v-btn>
          </template>
          <h4>Adicionar meio de recebimento</h4>
        </v-tooltip>
        <v-dialog
          v-model="cadRecegbimento"
          lazy
          :fullscreen="$vuetify.breakpoint.xs"
          width="500"
          transition="dialog-bottom-transition"
          persistent
        >
          <cad-pagamento
            v-if="!empresas"
            @carregar="
              listPagamentosExtra(),
              carregarPagamentosSecundarios()
            "
            @fechar="
              cadRecegbimento = false
            "
            @showSnackbar="showSnackbar"
          ></cad-pagamento>
          <meio-recebimento
            v-else
            @carregarMeios="pegarMRApetrus()"
            @fechar="cadRecegbimento = false"
          />
        </v-dialog>
      </v-toolbar>
      <template v-if="empresas">
        <v-flex xs12>
          <v-data-table
            :headers="meioHeaders"
            :items="meios_recebimento"
            :loading="loading"
            :total-items="totalItems"
            hide-actions
          >
            <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
            <template v-slot:headers>
              <tr>
                <th></th>
                <th class="text-xs-left">Descrição</th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr>
                <td style="width: 10px">
                  <v-icon color="success">check_circle_outline</v-icon>
                </td>
                <td  class="text-xs-left" >{{ props.item.descricao }}</td>
                <td>
                  <v-menu
                    offset-x
                    max-width="230"
                    min-width="230"
                    right
                    transition="slide-x-transition"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" icon>
                        <v-icon color="error">delete</v-icon>
                      </v-btn>
                    </template>
                    <v-card max-width="230" min-width="230">
                      <v-card-title>
                        <h3 class="error--text" style="width: 100%; text-align: center;">Deseja excluir {{props.item.descricao}}?</h3>
                      </v-card-title>
                      <v-card-actions class="justify-space-around">
                        <v-btn small round class="mb-2">Não</v-btn>
                        <v-btn small round class="mb-2" color="error" @click="deletarMeio(props.item.id)">SIM</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-menu>
                  <v-menu
                    offset-x
                    max-width="230"
                    min-width="230"
                    right
                    transition="slide-x-transition"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" icon>
                        <v-icon color="info">remove_red_eye</v-icon>
                      </v-btn>
                    </template>
                    <v-card width="230">
                      <v-card-title>
                        <h3 class="info--text" style="width: 100%; text-align: center;">{{props.item.descricao}}</h3>
                      </v-card-title>
                      <v-card-text class="pa-2">
                        <v-flex v-if="props.item.chave_pix">
                          <h3 style="width: 100%; text-align: center;">Chave PIX: {{props.item.chave_pix}}</h3>
                          <v-layout justify-center>
                            <v-tooltip bottom>
                              <v-btn slot="activator" icon small @click="copiar(props.item.chave_pix)"><v-icon color="info">content_copy</v-icon></v-btn>
                              <span>Copiar</span>
                            </v-tooltip>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 v-if="props.item.cod_boleto">
                          <h3>Código do Boleto:</h3> <h5 style="hite-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{props.item.cod_boleto}}</h5>
                          <v-layout justify-center>
                            <v-tooltip bottom>
                              <v-btn slot="activator" icon small @click="copiar(props.item.cod_boleto)"><v-icon color="info">content_copy</v-icon></v-btn>
                              <span>Copiar</span>
                            </v-tooltip>
                          </v-layout>
                        </v-flex>
                        <h3 style="width: 100%; text-align: center;" v-if="props.item.banco">{{props.item.banco}}</h3>
                        <h3 v-if="props.item.agencia">Agencia: {{props.item.agencia}}</h3>
                        <h3 v-if="props.item.conta">Conta: {{props.item.conta}}</h3>
                        <h3 v-if="props.item.tipo_conta">{{tipos_conta[props.item.tipo_conta - 1].descricao}}</h3>
                        <h3 style="width: 100%; text-align: center;" v-if="props.item.tipo == 4">Aceita cartão de crédito</h3>
                        <h3 style="width: 100%; text-align: center;" v-if="props.item.tipo == 5">Aceita cartão de débito</h3>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </template>
      <template v-else>
        <v-flex>
          <v-data-table
            hide-actions
            :loading="loading"
            :items="pagamentosExtra"
            :hide-headers="!pagamentosExtra.length"
            class="elevation-1"
          >
            <template v-slot:headers>
              <tr>
                <th></th>
                <th class="text-xs-center">Descrição</th>
                <th class="text-xs-center">Destino</th>
                <th v-for="tp in tiposPagamento" :key="tp.id" class="text-xs-center">{{tp.descricao}}</th>
                <th class="text-xs-center">Habilitar</th>
                <th></th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr>
                <td class="text-xs-left">
                  <v-avatar>
                    <v-icon class="primary--text">credit_card</v-icon>
                  </v-avatar>
                </td>
                <td
                  class="text-xs-center"
                >
                  {{ props.item.forma_pagamento.descricao }}
                </td>
                <td
                  class="text-xs-center"
                >
                  {{ destinos[props.item.destino] }}
                </td>
                <td
                  v-for="tp in tiposPagamento"
                  :key="tp.id_tipo_pagamento"
                  class="text-xs-center"
                >
                  <v-layout
                    align-center
                    justify-center
                  >
                    <template v-if="props.item.forma_pagamento[tp.referencia]">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-radio
                            v-show="!props.item[tp.referencia]"
                            v-on="on"
                            @click.stop="() => ativarPagamento(props.item.id, tp.id_tipo_pagamento, 0)"
                          ></v-radio>
                          <v-layout
                            v-show="props.item[tp.referencia]"
                            justify-center
                            align-center
                          >
                          <v-icon color="green" class="pr-1" @click.stop="() => ativarPagamento(props.item.id, tp.id_tipo_pagamento, 1)">check_circle</v-icon>
                          </v-layout>
                        </template>
                        Somente um pagamento com {{tp.descricao}} pode ficar marcado como ativo.
                      </v-tooltip>
                    </template>
                    <template v-else>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-avatar v-on="on" >
                            <v-icon class="red--text">block</v-icon>
                          </v-avatar>
                        </template>
                        Esta forma de pagamento não permite débito.
                      </v-tooltip>
                    </template>
                  </v-layout>
                </td>
                <td style="width: 10px">
                  <v-tooltip lazy bottom>
                    <template v-slot:activator="{ on }">
                      <v-switch
                        class="mt-4"
                        v-on="on"
                        v-model="props.item.forma_pagamento.disponivel"
                        readonly
                        @click.stop="() => habilitarPagamento(props.item.forma_pagamento.id)"
                        color="primary"
                      >
                      </v-switch>
                    </template>
                    Mudar dispobilidade
                  </v-tooltip>
                </td>
                <td class="text-xs-right">
                  <v-tooltip lazy bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        icon
                        @click="
                          meioSelecionado = props.item,
                          editar_destino = true
                        "
                      >
                        <v-icon color="primary">edit</v-icon>
                      </v-btn>
                    </template>
                    <span>Editar Destino</span>
                  </v-tooltip>
                  <v-tooltip lazy bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn icon v-on="on" @click="apagarPagamento(props.item)">
                        <v-icon color="error">delete</v-icon>
                      </v-btn>
                    </template>
                    Apagar
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
        <v-toolbar-title class="secondary--text mt-4 mb-2">
          Meios recebimentos secundários
        </v-toolbar-title>
        <v-flex>
          <v-data-table
            hide-actions
            :loading="loading"
            :items="pagamentosSecundarios"
            :hide-headers="!pagamentosSecundarios.length"
            class="elevation-1"
          >
            <template v-slot:headers>
              <tr>
                <th></th>
                <th class="text-xs-center">Descrição</th>
                <th class="text-xs-center">Destino</th>
                <th v-for="tp in tiposPagamento" :key="tp.id" class="text-xs-center">{{tp.descricao}}</th>
                <th class="text-xs-center">Habilitar</th>
                <th></th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr>
                <td class="text-xs-left">
                  <v-avatar>
                    <v-icon class="teal--text">pix</v-icon>
                  </v-avatar>
                </td>
                <td class="text-xs-center">{{ props.item.forma_pagamento.descricao }}</td>
                <td class="text-xs-center">
                  {{ destinos[props.item.destino] }}
                </td>
                <td
                  v-for="tp in tiposPagamento"
                  :key="tp.id_tipo_pagamento"
                  class="text-xs-center"
                >
                  <v-layout
                    align-center
                    justify-center
                  >
                    <template
                      v-if="props.item.forma_pagamento[tp.referencia]"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-radio
                            v-show="!props.item[tp.referencia]"
                            v-on="on"
                            @click.stop="() => ativarPagamento(props.item.id, tp.id_tipo_pagamento, 0)"
                          ></v-radio>
                          <v-layout
                            v-show="props.item[tp.referencia]"
                            justify-center
                            align-center
                          >
                          <v-icon color="green" class="pr-1" @click.stop="() => ativarPagamento(props.item.id, tp.id_tipo_pagamento, 1)">check_circle</v-icon>
                          </v-layout>
                        </template>
                        Somente um pagamento com {{tp.descricao}} pode ficar marcado como ativo.
                      </v-tooltip>
                    </template>
                    <template v-else>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-avatar v-on="on" >
                            <v-icon class="red--text">block</v-icon>
                          </v-avatar>
                        </template>
                        Esta forma de pagamento não ser vinculada.
                      </v-tooltip>
                    </template>
                  </v-layout>
                </td>
                <td style="width: 10px">
                  <v-tooltip lazy bottom>
                      <template v-slot:activator="{ on }">
                        <v-switch
                          class="mt-4"
                          v-on="on"
                          v-model="props.item.forma_pagamento.disponivel"
                          readonly
                          @click.stop="() => habilitarPagamento(props.item.forma_pagamento.id)"
                          color="primary"
                        >
                        </v-switch>
                      </template>
                      Mudar disponibilidade
                    </v-tooltip>
                </td>
                <td class="text-xs-right">
                  <v-tooltip lazy bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        icon
                        @click="
                          meioSelecionado = props.item,
                          editar_destino = true
                        "
                      >
                        <v-icon color="primary">edit</v-icon>
                      </v-btn>
                    </template>
                    <span>Editar Destino</span>
                  </v-tooltip>
                  <v-tooltip lazy bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn icon v-on="on" @click="apagarPagamento(props.item)">
                        <v-icon color="error">delete</v-icon>
                      </v-btn>
                    </template>
                    Apagar
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </template>
    </v-layout>
    <v-dialog
      v-model="editar_destino"
      v-if="editar_destino"
      width="500"
    >
      <editar-meio-recebimento
        @fechar="
          editar_destino = false,
          meioSelecionado = undefined
        "
        :meioSelecionado="meioSelecionado"
        @showSnackbar="showSnackbar"
      />
    </v-dialog>
    <v-snackbar
      v-model="snackbar.active"
      :color="snackbar.color"
      :multi-line="snackbar.multiLine"
      :timeout="snackbar.timeout"
      :vertical="snackbar.vertical"
    >
      {{ snackbar.text }}
      <v-btn
        flat
        @click="snackbar.active = false"
      >
        Fechar
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import SmartLockMessage from '@/components/SmartLockMessage'
import MeioRecebimento from '@/components/cadastros/CadMeioRecebimento'
import CadPagamento from '@/components/cadastros/CadPagExtra'
import EditarMeioRecebimento from '@/components/dialogs/EditarMeioRecebimento'

export default {
    components: {
      SmartLockMessage,
      MeioRecebimento,
      CadPagamento,
      EditarMeioRecebimento
    },
    data: () => ({
        meios_recebimento: [],
        totalItems: 0,
        cadRecegbimento: false,
        editar_destino: false,
        meioSelecionado: undefined,
        snackbar: {
        active: false,
        color: '',
        multiLine: true,
        timeout: 4000,
        vertical: true,
        text: ''
      },
      pagination: {
        rowsPerPage: 5,
        page: 1
      },
      meioHeaders: [
        {
          sortable: false,
          align: 'right'
        },
        {
          text: 'Descrição',
          sortable: false,
          align: 'left'
        },
        {
          sortable: false,
          align: 'right'
        }
      ],
      tipos_conta: [
        {
          descricao: 'Conta Corrente',
          id: 1
        },
        {
          descricao: 'Conta Poupança',
          id: 2
        },
        {
          descricao: 'Conta Conjunta',
          id: 3
        },
        {
          descricao: 'Conta Salário',
          id: 4
        }
      ],
      empresas: false,
      dialogNovoPagamento: false,
      dialogAutenticacao: false,
      destinos: {
        1: 'Clientes',
        2: 'Postos',
        3: 'Empresas',
        4: 'Todos'
      }
    }),
    beforeMount () {
      if (this.headers) {
        this.pegarMRApetrus()
        this.listPagamentosExtra()
        this.carregarTiposPagamento()
        this.carregarFormasPagamento()
        this.carregarPagamentosSecundarios()
      }
    },
    computed: {
      smartLock () {
          return this.$store.getters.smartLock
      },
      headers () {
        return this.$store.getters.headers
      },
      loading () {
          return this.$store.getters.loading
      },
      tiposPagamento () {
        return this.$store.getters.tiposPag
      },
      formasPag () {
        return this.$store.getters.formasPag
      },
      totalItemsFormasPag () {
        return this.$store.getters.totalItemsFormasPag
      },
      pagamentosExtra () {
        return this.$store.getters.pagamentosExtra.map(
          (pagExtra) => {
            let pag = {
              id: pagExtra.id,
              destino: pagExtra.destino
            }
            this.tiposPagamento.forEach(tp => {
              if (!pagExtra.tipos_pagamento || !pagExtra.tipos_pagamento.find(t => t.referencia === tp.referencia)) {
                pag[`${tp.referencia}`] = false
              } else {
                pag[`${tp.referencia}`] = true
              }
            })
            pag.forma_pagamento = {
              id: pagExtra.forma_pagamento.id_forma_pagamento,
              credito: pagExtra.forma_pagamento.aceita_credito,
              debito: pagExtra.forma_pagamento.aceita_debito,
              pix: pagExtra.forma_pagamento.aceita_pix,
              boleto: pagExtra.forma_pagamento.aceita_boleto,
              cashback: pagExtra.forma_pagamento.aceita_cashback,
              descricao: pagExtra.forma_pagamento.descricao,
              disponivel: pagExtra.forma_pagamento.disponivel
            }
            return pag
          }
        )
      },
      pagamentosSecundarios () {
      return this.$store.getters.pagamentosSecundarios.map(
        (pagExtra) => {
          let pag = {
            id: pagExtra.id,
            destino: pagExtra.destino
          }
          this.tiposPagamento.forEach(tp => {
            if (!pagExtra.tipos_pagamento || !pagExtra.tipos_pagamento.find(t => t.referencia === tp.referencia)) {
              pag[`${tp.referencia}`] = false
            } else {
              pag[`${tp.referencia}`] = true
            }
          })
          pag.forma_pagamento = {
            id: pagExtra.forma_pagamento.id_forma_pagamento,
            credito: pagExtra.forma_pagamento.aceita_credito,
            debito: pagExtra.forma_pagamento.aceita_debito,
            pix: pagExtra.forma_pagamento.aceita_pix,
            boleto: pagExtra.forma_pagamento.aceita_boleto,
            cashback: pagExtra.forma_pagamento.aceita_cashback,
            descricao: pagExtra.forma_pagamento.descricao,
            disponivel: pagExtra.forma_pagamento.disponivel,
            pagamento_secundario: pagExtra.forma_pagamento.pagamento_secundario
          }
          return pag
        }
      )
    }
    },
    watch: {
      headers (val) {
        if (val) {
          this.pegarMRApetrus()
          this.listPagamentosExtra()
          this.carregarTiposPagamento()
          this.carregarFormasPagamento()
          this.carregarPagamentosSecundarios()
        }
      }
    },
    methods: {
      pegarMRApetrus () {
          this.$store.dispatch('meioRecebimentoApetrus', { method: 'GET' }).then(json => {
            this.meios_recebimento = json
          })
      },
      deletarMeio (id) {
        this.$store.dispatch('meioRecebimentoApetrus', { id: id, method: 'DELETE' }).then(this.pegarMRApetrus())
      },
      copiar (texto) {
        navigator.clipboard.writeText(texto)
        alert('Copiado')
      },
      carregarFormasPagamento () {
        this.$store.dispatch('carregarFormasPagamento', this.pagination)
      },
      carregarTiposPagamento () {
        this.$store.dispatch('carregarTiposPagamento')
      },
      listPagamentosExtra () {
        this.$store.dispatch('listPagamentosExtra')
      },
      carregarPagamentosSecundarios () {
        this.$store.dispatch('carregarPagamentosSecundarios')
      },
      apagarPagamento (pagamento) {
        this.$store.dispatch(
          'desvincularPagamentoExtra',
          pagamento.id
        ).then(() => {
          this.showSnackbar(
            'Pagamento apagado com sucesso.',
            'primary'
          )
        }).catch(() => {
          this.showSnackbar(
            'Não foi possível apagar meio de recebimento',
            'error'
          )
        })
      },
      ativarPagamento (idMeioPagamento, idTipoPagamento, deletar) {
        this.$store.dispatch('ativarPagamentoExtra', {
          id_meio_pagamento: idMeioPagamento,
          tipo_pagamento: idTipoPagamento,
          deletar
        }).then(() => {
          this.showSnackbar(
            'Pagamento ativo com sucesso.',
            'primary'
          )
        }).catch(() => {
          this.showSnackbar(
            'Não foi possível ativar pagamento',
            'error'
          )
        })
      },
      habilitarPagamento (idTipoPagamento) {
        this.$store.dispatch('habilitarPagamentoExtra',
          idTipoPagamento
        ).then(() => {
          this.showSnackbar(
            'Pagamento habilitado com sucesso.',
            'primary'
          )
        }).catch(() => {
          this.showSnackbar(
            'Não foi possível habilitar pagamento',
            'error'
          )
        })
      },
      showSnackbar (text, type) {
        this.snackbar.text = text
        this.snackbar.color = type
        this.snackbar.active = true
      }
    }
}
</script>
